import { useCallback, useEffect, useState } from "react";

const ITEMS_TO_SHOW = 8;

/**
 * Hook for paginating a list with "show more" / "show less".
 * Resets visible count when `resetKey` (e.g. groupId) changes.
 */
export const useExpandablePagination = <T>(items: T[], resetKey: string) => {
  const [visibleCount, setVisibleCount] = useState<number>(ITEMS_TO_SHOW);

  useEffect(() => {
    setVisibleCount(ITEMS_TO_SHOW);
  }, [resetKey]);

  const hasMoreToShow = visibleCount < items.length;
  const canShowLess = visibleCount > ITEMS_TO_SHOW;

  const showMore = useCallback(() => {
    setVisibleCount((prev) => Math.min(prev + ITEMS_TO_SHOW, items.length));
  }, [items.length]);

  const showLess = useCallback(() => {
    setVisibleCount(ITEMS_TO_SHOW);
  }, []);

  return {
    showMore,
    showLess,
    hasMoreToShow,
    canShowLess,
    visibleCount,
  };
};
